import axios from "axios";
import moment from 'moment-timezone';
import { adminAuthActions } from "../store/adminAuth";
import { resetFilters } from "../store/orderFilters";


// Common timezone header interceptor logic
const attachTimezoneInterceptor = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      config.headers['Timezone'] = moment.tz.guess(true);;
      return config;
    },
    (error) => Promise.reject(error)
  );
};

// Instance for /v1/
const apiV1 = axios.create({
  baseURL: '/v1/',
});
attachTimezoneInterceptor(apiV1);

// Instance for /v2/
const apiV2 = axios.create({
  baseURL: '/v2/',
});
attachTimezoneInterceptor(apiV2);
const errorHandler = (err, dispatch) => {
  let errorMessage = {};
  switch (err.response && err.response.status) {
    case 401:
      errorMessage.severity = 'error';
      errorMessage.summary = err.response?.statusText ? err.response.statusText : "Error";
      errorMessage.errorMsg = err.response?.data?.errorMsg ? err.response.data.errorMsg : "Session Expired";
      dispatch(adminAuthActions.onLogout()); dispatch(resetFilters());
      break;
    default:
      errorMessage.severity = 'error';
      errorMessage.summary = err.response?.statusText ? err.response?.statusText : "Error";
      errorMessage.errorMsg = err.response?.data?.errorMsg ? err.response.data.errorMsg : "Something went wrong, please try again";
      break;
  }
  return errorMessage;
}

export const login = (data, dispatch, callback) => {
  apiV1.post('login', data)
    .then(response => {
      const sessionId = response.headers['sessionid'];
      if (response && sessionId) {
        response.data.sessionId = sessionId;
        callback({ result: 'SUCCESS', data: response.data });
      } else {
        callback({ result: "FAILED", data: 'Failed' });
      }
    }).catch(error => {
      if (error.status === 303 && error?.response?.data?.otpEnabled) {
        callback({ result: 'SUCCESS', data: error?.response.data });
        return
      }
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}
export const otpApi = (data, dispatch, callback) => {
  apiV1.post('login/otp', data)
    .then(response => {
      if (response) {
        const sessionId = response.headers['sessionid'];
        response.data.sessionId = sessionId;
        callback({ result: 'SUCCESS', data: response.data });
      } else {
        callback({ result: "FAILED", data: 'Failed' });
      }
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getUsersList = (obj, headers, dispatch, callback) => {
  const paramsObj = {
    offset: obj.offset,
    limit: obj.limit,
    orderBy: obj.sortField,
    direction: obj.sortOrder,
    name: obj.name,
    email: obj.email,
    phone: obj.phone,
    affiliateName: obj.affiliateName,
    createdDateFrom: obj.createdDateFrom,
    createdDateTo: obj.createdDateTo,
  };

  const filtered = Object.fromEntries(
    Object.entries(paramsObj).filter(([_, v]) =>
      v !== "" && v !== null && v !== undefined
    )
  );

  const params = "?" + new URLSearchParams(filtered).toString();
  apiV1.get('users' + params, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const affiliateusers = (data, headers, dispatch, callback) => {
  apiV1.post('users/affiliateupdate', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getAffiliateUsersList = (obj, headers, dispatch, callback) => {
  const paramsObj = {
    offset: obj.offset,
    limit: obj.limit,
    orderBy: obj.sortField,
    direction: obj.sortOrder,
    name: obj.name,
    email: obj.email,
    phone: obj.phone,
    createdDateFrom: obj.createdDateFrom,
    createdDateTo: obj.createdDateTo,
    isActive: obj.isActive,
    affiliateName: obj.affiliateName,
    type: obj.type,
  };

  // remove empty, null, undefined
  const filtered = Object.fromEntries(
    Object.entries(paramsObj).filter(([_, v]) =>
      v !== "" && v !== null && v !== undefined
    )
  );

  const params = "?" + new URLSearchParams(filtered).toString();
  apiV1.get('affiliates' + params, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getAllAffiliates = (arg1, arg2, arg3, arg4) => {
  let headers, dispatch, callback;
  if (typeof arg3 === 'function') {
    headers = arg1;
    dispatch = arg2;
    callback = arg3;
  } else {
    headers = arg2;
    dispatch = arg3;
    callback = arg4;
  }
  apiV1.get('affiliates/all', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const getAllAffiliatesList = getAllAffiliates;

export const getUserDetails = (id, headers, dispatch, callback) => {
  apiV1.get(`users/${id}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}



export const createAffiliates = (data, headers, dispatch, callback) => {
  apiV1.post('affiliates', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const createChildAffiliate = (afid, data, headers, dispatch, callback) => {
  apiV1.post(`affiliates/${afid}/children`, data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getChildAffiliates = (afid, headers, dispatch, callback) => {
  apiV1.get(`affiliates/${afid}/children`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updateAffiliates = (data, headers, dispatch, callback) => {
  apiV1.put('affiliates', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}


export const updateUser = (data, headers, dispatch, callback) => {
  apiV1.put('users', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}


export const getOrdersList = (obj, headers, dispatch, callback) => {
  const paramsObj = {
    userId: obj.userId,
    listingType: obj.listingType,
    offset: obj.offset,
    limit: obj.limit,
    orderBy: obj.sortField,
    direction: obj.sortOrder,
    name: obj.name,
    orderId: obj.orderId,
    affiliateName: obj.affiliateName,
    purchaseDateFrom: obj.purchaseDateFrom,
    purchaseDateTo: obj.purchaseDateTo,
    orderStatus: obj.orderStatus,
    paymentStatus: obj.paymentStatus,
    paymentGateway: obj.paymentGateway,
    providerName: obj.providerName,
    promoCode: obj.promoCode,
    keyword: obj.keyword,
    simType: obj.simType,
  };

  const filtered = Object.fromEntries(
    Object.entries(paramsObj).filter(([_, v]) =>
      v !== "" && v !== null && v !== undefined
    )
  );

  const params = "?" + new URLSearchParams(filtered).toString();
  apiV1.get('orders' + params, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getOrderDetails = (orderid, headers, dispatch, callback) => {
  apiV1.get(`orders/${orderid}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getUserEmail = (data, userId, headers, dispatch, callback) => {
  apiV1.post(`users/${userId}/contact`, data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getCountriesList = (headers, dispatch, callback) => {
  apiV1.get('countries', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data, ipcountry: response.headers['x-cf-ipcountry'] });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getCatalogsList = (req, headers, dispatch, callback) => {
  apiV2.get('prices?' + req, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getWholesaleList = (req, headers, dispatch, callback) => {
  apiV1.get('wholesale?' + req, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}


export const getPromoCodesList = (obj, headers, dispatch, callback) => {
  apiV1.get('promocodes?startTs=' + obj.startTs + '&endTs=' + obj.endTs + '&status=' + obj.status + '&type=' + obj.type, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const modifyPromoCode = (request, headers, dispatch, callback) => {
  const method = request.id ? "put" : "post"
  apiV1[method]('promocodes', request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getVouchersList = (obj, headers, dispatch, callback) => {
  apiV1.get('vouchers?startTs=' + obj.startTs + '&endTs=' + obj.endTs + '&status=' + obj.status + '&type=' + obj.type, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const modifyVoucher = (request, headers, dispatch, callback) => {
  const method = request.id ? "put" : "post"
  apiV1[method]('vouchers', request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updatePrices = (data, headers, dispatch, callback) => {
  apiV1.put('prices', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updateWholesalePrices = (data, headers, dispatch, callback) => {
  apiV1.post('wholesale', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}


export const getSiteMaintenance = (headers, dispatch, callback) => {
  apiV1.get('sitemaintenanceconfig', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updateSiteMaintenance = (data, headers, dispatch, callback) => {
  apiV1.post('sitemaintenanceconfig', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const importPriceCsv = (data, headers, dispatch, callback) => {
  apiV1.post('uploadpricecsv', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getAssets = (headers, dispatch, callback) => {
  apiV1.get('assets', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const uploadAssetsApi = (data, headers, dispatch, callback) => {
  apiV1.post('uploadassets', data, { headers: headers })
    .then(response => {
      callback({ result: response.data === "success" ? 'SUCCESS' : "FAILED", data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const getLanguageTranslates = (lang, headers, dispatch, callback) => {
  apiV1.get('alltranslations', {
    params: { language: lang },
    headers: headers
  })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const uploadTranslations = (lang, payload, headers, dispatch, callback) => {
  const updatedHeaders = {
    ...headers,
    'language': lang,
  };
  apiV1
    .post('translate', payload, { headers: updatedHeaders })
    .then((response) => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const getTabs = (dispatch, headers, ids, startDate, endDate, callback) => {
  apiV1
    .get("monthlystats", {
      headers: headers,
      params: {
        ids: ids,
        dateFrom: startDate,
        dateTo: endDate
      },
    })
    .then((response) => {
      callback({ result: "SUCCESS", data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};




export const getRecurringTab = (dispatch, headers, startDate, endDate, callback) => {
  apiV1
    .get("monthlystats/recurringrevenue", {
      headers: headers,
      params: {
        dateFrom: startDate,
        dateTo: endDate
      },
    })
    .then((response) => {
      callback({ result: "SUCCESS", data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};

export const getActiveStats = (dispatch, headers, startDate, endDate, callback) => {
  apiV1
    .get("monthlystats/activesubscriptions", {
      headers: headers,
      params: {
        dateFrom: startDate,
        dateTo: endDate
      },
    })
    .then((response) => {
      callback({ result: "SUCCESS", data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};

export const getCancelledStats = (dispatch, headers, startDate, endDate, callback) => {
  apiV1
    .get("monthlystats/cancelledsubscriptions", {
      headers: headers,
      params: {
        dateFrom: startDate,
        dateTo: endDate
      },
    })
    .then((response) => {
      callback({ result: "SUCCESS", data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};

export const getGraphs = (dispatch, headers, id, startDate, endDate, callback) => {
  apiV1
    .get("monthgraph", {
      headers: headers,
      params: {
        id: id,
        dateFrom: startDate,
        dateTo: endDate
      },
    })
    .then((response) => {
      callback({ result: "SUCCESS", data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};

export const getActiveGraph = (dispatch, headers, startDate, endDate, callback) => {
  apiV1
    .get("monthgraph/activesubscriptions", {
      headers: headers,
      params: {
        dateFrom: startDate,
        dateTo: endDate
      },
    })
    .then((response) => {
      callback({ result: "SUCCESS", data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};

export const getMonthGraphs = (dispatch, headers, startDate, endDate, callback) => {
  apiV1
    .get("monthgraph/topbundlesmonth", {
      headers: headers,
      params: {
        dateFrom: startDate,
        dateTo: endDate
      },
    })
    .then((response) => {
      callback({ result: "SUCCESS", data: response.data });
    })
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};

export const getPriceFilters = (headers, dispatch, callback) => {
  apiV2.get('prices/filters', {
    headers: headers
  })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getNotes = (dispatch, headers, id, callback) => {
  apiV1.get(`orders/${id}/notes`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const postNotes = (obj, dispatch, headers, id, callback) => {
  apiV1.post(`orders/${id}/notes`, obj, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const retryOrderStatus = (dispatch, headers, id, callback) => {
  apiV1.put(`orders/${id}/retry`, {}, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const updateShippingStatus = (id, obj, headers, dispatch, callback) => {
  apiV1.put(`orders/${id}/shipping-status`, obj, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const getOrderInfo = (obj, dispatch, headers, callback) => {
  apiV1.post(`orders`, obj, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const networkInfo = (dispatch, headers, iccid, callback) => {
  apiV1.get(`esims/${iccid}/networkdetails`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

/* ==================== Promo Code Batch APIs ==================== */

export const getPromoBatchList = (req, headers, dispatch, callback) => {
  apiV1.get('promocodes/batch?' + req, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getPromoBatchInfo = (req, headers, dispatch, callback) => {
  apiV1.get(`promocodes/batch?batchId=${req.id}&status=${req.status}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const sharePromoEmail = (request, headers, dispatch, callback) => {
  apiV1.post(`promocodes/${request?.id}/share`, request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const createPromoBatch = (request, headers, dispatch, callback) => {
  apiV1.post('promocodes/batch', request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updatePromoBatch = (request, headers, dispatch, callback) => {
  apiV1.put('promocodes/batch', request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

/* ==================== Prepaid Voucher Batch APIs ==================== */

export const getVoucherBatchList = (req, headers, dispatch, callback) => {
  apiV1.get('vouchers/batch?' + req, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getVoucherBatchInfo = (req, headers, dispatch, callback) => {
  apiV1.get(`vouchers/batch?batchId=${req.id}&status=${req.status}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const shareVoucherEmail = (request, headers, dispatch, callback) => {
  apiV1.post(`vouchers/${request?.id}/share`, request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const createVoucherBatch = (request, headers, dispatch, callback) => {
  apiV1.post('vouchers/batch', request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updateVoucherBatch = (request, headers, dispatch, callback) => {
  apiV1.put('vouchers/batch', request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const reserveBatchVouchers = (id, request, headers, dispatch, callback) => {
  apiV1.post(`vouchers/batch/${id}/reserve`, request, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

// export const fraudulentAPI = (obj, dispatch, headers, id, callback) => {
//     apiV1.put(`orders/${id}/fraud`, obj, { headers: headers })
//       .then(response => {
//         callback({ result: 'SUCCESS', data: response.data});
//     })
//       .catch(error => {
//         const errorMessage = errorHandler(error, dispatch);
//         callback({ result: 'FAILED', error: errorMessage });
//       });
// };
// export const refundAPI = (obj, dispatch, headers, id, callback) => {
//     apiV1.put(`orders/${id}/refund`, obj, { headers: headers })
//       .then(response => {
//         callback({ result: 'SUCCESS', data: response.data});
//     })
//       .catch(error => {
//         const errorMessage = errorHandler(error, dispatch);
//         callback({ result: 'FAILED', error: errorMessage });
//       });
// };
export const refundNewAPI = (obj, dispatch, headers, id, callback) => {
  apiV2.put(`orders/${id}/refund`, obj, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};
export const affiliateActivateAPI = (obj, dispatch, headers, id, callback) => {
  apiV1.put(`affiliates/${id}/activate`, obj, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};
export const affiliateUserActivateAPI = (obj, dispatch, headers, callback) => {
  apiV1.put(`affiliates`, obj, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};
export const affiliateDeactivateAPI = (id, dispatch, headers, callback) => {
  apiV1.put(`affiliates/${id}/deactivate`, {}, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const esimsV2 = (userId, headers, dispatch, callback) => {
  apiV1.get(`${userId}/esims`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const esimsICCID = (iccid, headers, dispatch, callback) => {
  apiV1.get(`esims/${iccid}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const deleteUserEsim = (userId, iccid, headers, dispatch, callback) => {
  apiV1.delete(`users/${userId}/esims/${iccid}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const restoreUserEsim = (userId, iccid, headers, dispatch, callback) => {
  apiV1.put(`users/${userId}/esims/${iccid}`, {}, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getEsimCapabilities = (iccid, headers, dispatch, callback) => {
  apiV1.get(`esims/${iccid}/capabilities`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const resetEsim = (iccid, headers, dispatch, callback) => {
  apiV1.put(`esims/${iccid}/reset`, {}, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}
export const refreshEsim = (iccid, headers, dispatch, callback) => {
  apiV1.put(`esims/${iccid}/refresh`, {}, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getEsimNotes = (arg1, arg2, arg3, arg4) => {
  let iccid, headers, dispatch, callback;
  if (typeof arg1 === 'function') {
    dispatch = arg1;
    headers = arg2;
    iccid = arg3;
    callback = arg4;
  } else {
    iccid = arg1;
    headers = arg2;
    dispatch = arg3;
    callback = arg4;
  }
  apiV1.get(`esims/${iccid}/notes`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};


export const getSettlementReport = (data, headers, dispatch, callback) => {
  const { affiliateId, month, year } = data;

  const params = new URLSearchParams();
  if (month) params.append("month", month);
  if (year) params.append("year", year);

  const baseUrl = affiliateId ? `reports/settlement/${affiliateId}` : `reports/settlement`;
  const url = `${baseUrl}${params.toString() ? `?${params}` : ""}`;

  apiV1
    .get(url, { headers })
    .then((response) => callback({ result: "SUCCESS", data: response.data }))
    .catch((error) => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: "FAILED", error: errorMessage });
    });
};



export const updateCustomerName = (obj, headers, dispatch, callback) => {
  apiV1.put(`users`, obj, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    })
    .catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const getDashboardLogin = (headers, dispatch, callback) => {
  apiV1.get(`dashboard/login`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}
export const getReceiversCount = (data, headers, dispatch, callback) => {
  apiV2.post(`push-notifications/receivers`, data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}
export const sendPushNotifications = (data, headers, dispatch, callback) => {
  apiV2.post(`push-notifications/`, data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}
export const getNotifcations = (obj, headers, dispatch, callback) => {
  const paramsObj = {
    offset: obj.offset,
    limit: obj.limit,
    orderBy: obj.sortField,
    direction: obj.sortOrder,
    status: obj.status,
    affiliateName: obj.affiliateName,
    createdFromDate: obj.createdFromDate,
    createdToDate: obj.createdToDate,
    archived: obj.archived,
  };

  const filtered = Object.fromEntries(
    Object.entries(paramsObj).filter(([_, v]) =>
      v !== "" && v !== null && v !== undefined
    )
  );

  const params = "?" + new URLSearchParams(filtered).toString();
  apiV2.get('push-notifications/' + params, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const archiveNotification = (jobId, headers, dispatch, callback) => {
  apiV2.post(`push-notifications/${jobId}/archive`, {}, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const unarchiveNotification = (jobId, headers, dispatch, callback) => {
  apiV2.post(`push-notifications/${jobId}/unarchive`, {}, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getAdminsList = (headers, dispatch, callback) => {
  apiV1.get('admins', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const createAdmin = (data, headers, dispatch, callback) => {
  apiV1.post('admins', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updateAdmin = (adminId, data, headers, dispatch, callback) => {
  apiV1.put(`admins/${adminId}`, data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const deleteAdmin = (adminId, headers, dispatch, callback) => {
  apiV1.delete(`admins/${adminId}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getUserByEmail = (email, headers, dispatch, callback) => {
  apiV1.get(`user?email=${encodeURIComponent(email)}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      if (error.response && error.response.status === 404) {
        callback({ result: 'NOT_FOUND', status: 404 });
      } else {
        const errorMessage = errorHandler(error, dispatch);
        callback({ result: 'FAILED', error: errorMessage });
      }
    })
}

export const createEndUser = (data, headers, dispatch, callback) => {
  apiV1.post('user', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const createOnboardingOrder = (data, headers, dispatch, callback) => {
  apiV1.post('order', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getSubscriptionPlans = (headers, dispatch, callback) => {
  apiV1.get('subscription-plans', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getSubscriptionBundles = (headers, dispatch, callback) => {
  apiV1.get('subscription-bundles', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      if (typeof error?.response?.data === 'string' && error.response.data) {
        errorMessage.errorMsg = error.response.data;
      } else if (error?.response?.data?.message) {
        errorMessage.errorMsg = error.response.data.message;
      }
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const getAffiliates = getAllAffiliates;

export const getEmailTemplates = (headers, dispatch, callback) => {
  apiV1.get('email-templates', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getEmailTemplateDetails = (type, locale, headers, dispatch, callback) => {
  apiV1.get(`email-templates/${type}/${locale}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updateEmailTemplate = (type, locale, data, headers, dispatch, callback) => {
  apiV1.put(`email-templates/${type}/${locale}`, data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const deleteEmailTemplate = (type, locale, headers, dispatch, callback) => {
  apiV1.delete(`email-templates/${type}/${locale}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const translateEmailTemplate = (type, locales, headers, dispatch, callback) => {
  apiV1.post(`email-templates/${type}/translate`, { locales: locales }, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const testSendEmailTemplate = (data, headers, dispatch, callback) => {
  apiV1.post('email-templates/test-send', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getEmailLanguages = (headers, dispatch, callback) => {
  callback({ result: 'SUCCESS', data: ['en', 'es'] });
}

export const getEditorConfig = (headers, dispatch, callback) => {
  apiV1.get('email-templates/editor-config', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const updateEditorConfig = (data, headers, dispatch, callback) => {
  apiV1.put('email-templates/editor-config', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const getKycCountries = (headers, dispatch, callback) => {
  apiV1.get('kyc/countries', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const addKycCountry = (data, headers, dispatch, callback) => {
  apiV1.post('kyc/countries', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const deleteKycCountry = (iso, headers, dispatch, callback) => {
  apiV1.delete(`kyc/countries/${iso}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}
export const uploadSubscriptionPlanContractDocuments = (planName, formData, headers, dispatch, callback) => {
  apiV1.put(`subscription-plans/${encodeURIComponent(planName)}/contract-documents`, formData, {
    headers: {
      ...headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const downloadSubscriptionPlanContractDocument = (planName, docType, headers, dispatch, callback) => {
  apiV1.get(`subscription-plans/${encodeURIComponent(planName)}/contract-documents/${encodeURIComponent(docType)}`, {
    headers: headers,
    responseType: 'blob',
  })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data, headers: response.headers });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const deleteSubscriptionPlanContractDocuments = (planName, headers, dispatch, callback) => {
  apiV1.delete(`subscription-plans/${encodeURIComponent(planName)}/contract-documents`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      callback({ result: 'FAILED', error: errorMessage });
    })
}

export const createSubscriptionPlan = (data, headers, dispatch, callback) => {
  apiV1.post('subscription-plans', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      if (typeof error?.response?.data === 'string' && error.response.data) {
        errorMessage.errorMsg = error.response.data;
      } else if (error?.response?.data?.message) {
        errorMessage.errorMsg = error.response.data.message;
      }
      callback({ result: 'FAILED', error: errorMessage });
    });
};


export const getDeviceTypes = (headers, dispatch, callback) => {
  apiV1.get('device-types', { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      if (typeof error?.response?.data === 'string' && error.response.data) {
        errorMessage.errorMsg = error.response.data;
      }
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const createDeviceType = (data, headers, dispatch, callback) => {
  apiV1.post('device-types', data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      if (typeof error?.response?.data === 'string' && error.response.data) {
        errorMessage.errorMsg = error.response.data;
      }
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const updateDeviceType = (id, data, headers, dispatch, callback) => {
  apiV1.put(`device-types/${id}`, data, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      if (typeof error?.response?.data === 'string' && error.response.data) {
        errorMessage.errorMsg = error.response.data;
      }
      callback({ result: 'FAILED', error: errorMessage });
    });
};

export const deleteDeviceType = (id, headers, dispatch, callback) => {
  apiV1.delete(`device-types/${id}`, { headers: headers })
    .then(response => {
      callback({ result: 'SUCCESS', data: response.data });
    }).catch(error => {
      const errorMessage = errorHandler(error, dispatch);
      if (typeof error?.response?.data === 'string' && error.response.data) {
        errorMessage.errorMsg = error.response.data;
      }
      callback({ result: 'FAILED', error: errorMessage });
    });
};